import { OverlayView } from "@react-google-maps/api";
import { memo } from "react";
import styled from "styled-components";

const PulseMarker = styled.div`
  background-color: #fff;
  border: 2px solid ${({isActive}) =>  isActive ? "var(--color-main)" : "#fff"};
  position: relative;
  overflow: hidden;
  width: ${({ isActive}) => !isActive ? "30px" : "50px"};
  height: ${({ isActive}) => !isActive ? "30px" : "50px"};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  animation: ${({animationControlType}) => animationControlType !== "animate" && "pulse 2s infinite"}; /* Animasyonu ekler */
  transform: translate(-50%, -50%);

.live-location {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.5); /* Başlangıç boyutu ve opaklığı */
  }
  70% {
    box-shadow: 0 0 0 20px rgba(255, 0, 0, 0); /* Genişler ve opaklık kaybolur */
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0); /* Biter */
  }
}
`


//! top listelerde haritada her bir sürücünün mevcut konumunu gösteren
const MemoizedOverlayDriverLocation = memo(({ position, imageUrl, animationControlType, handleClick, isActive }) => (
    <OverlayView position={position} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
      <PulseMarker animationControlType={animationControlType} onClick={handleClick} isActive={isActive}>
        <img src={imageUrl} alt="custom-marker" className="live-location" />
      </PulseMarker>
    </OverlayView>
  ));

export default MemoizedOverlayDriverLocation